import { SET_DISCONNECT_WALLET, SET_WALLET, SET_CONNECTED, SET_NAME, SET_TOKEN_BALANCE } from "../constants";

// the saved session is restored in App (helpers/session.js) once provider and signer are ready
// provider, signer and instance live in WalletSessionProvider (hooks/useWallet.jsx)
const initialState = {
  wallet: null,
  connected: false,
  wallet_name: null,
  balance: {},
};

// Reducer
export default function walletReducer(state = initialState, action) {
  switch (action.type) {
    case SET_WALLET:
      return { ...state, wallet: action.payload };
    case SET_CONNECTED:
      return { ...state, connected: action.payload };
    case SET_TOKEN_BALANCE:
      return { ...state, balance: { ...state.balance, [action.payload.contract]: action.payload.value } };
    case SET_NAME:
      return { ...state, wallet_name: action.payload };
    case SET_DISCONNECT_WALLET:
      return { ...state, wallet: null, connected: false, wallet_name: null };
    default:
      return state;
  }
}
